import type { CostContract, CostLineInput, CostProvisionalSummary } from '../types'
import { compareMoneyStrings, subtractMoneyStrings } from './contracts'
import type { ModuleActions } from './permissions'

/** "Čerpáno" (part D spec §2.3): what approved changes took from the allowance, original − remaining. */
export const provisionalDrawn = (s: Pick<CostProvisionalSummary, 'original' | 'remaining'>): string => subtractMoneyStrings(s.original, s.remaining)

/** Spec §2.4: "Čerpat z rezervy" needs CREATE and EDIT, an ACTIVE contract and something left to draw. */
export const canDrawProvisional = (a: ModuleActions, c: Pick<CostContract, 'status'>, s: Pick<CostProvisionalSummary, 'remaining'>): boolean =>
  a.canCreate && a.canEdit && c.status === 'ACTIVE' && compareMoneyStrings(s.remaining, '0') > 0

/** The draw dialog's first problem as an i18n key, or null: a title, and an amount above zero and at most what remains. */
export function drawProblem(title: string, amount: string | null, valid: boolean, remaining: string): string | null {
  if (!title.trim()) return 'CostControl_error_title_required'
  if (!valid || amount === null || compareMoneyStrings(amount, '0') <= 0) return 'CostControl_provisional_draw_problem_positive'
  if (compareMoneyStrings(amount, remaining) > 0) return 'CostControl_provisional_draw_problem_over'
  return null
}

/** Spec §2.4: the change's one line, negative, on the reserve item. */
export const drawLine = (nodeId: string, amount: string): CostLineInput => ({ nodeId, amount: subtractMoneyStrings('0', amount) })
